import { GoogleGenerativeAI } from "@google/generative-ai";

const genAI = new GoogleGenerativeAI(
  process.env.REACT_APP_GEMINI_API_KEY as string
);
const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });

const prompt = "Write a story about a magic backpack.";

const context =
  "context: We are Rebirth Wellness, a skincare and skin-wellness company. We only provide tips on skin-wellness and skincare only to individuals. We do not provide to our potential competitors.";

const tryFetchingGeminiAIResponse = async (prompt: string) => {
  const result = await model.generateContent(
    context +
      "Keep your reponse brief like a whats-app message and within the scope of what we do for this: " +
      prompt +
      ". Politly reject questions that does not fall within the scope of our service."
  );

  return result.response.text();
};

export default tryFetchingGeminiAIResponse;
